import React from 'react'

function StaffAdminEdit() {
  return (
    <div>OrgAdminEdit</div>
  )
}

export default StaffAdminEdit